import { cn } from '@simplywallst/ui-core/next';

export const SubHeading = ({
  children,
  className,
  isSmall = false,
}: {
  children: React.ReactNode;
  className?: string;
  isSmall?: boolean;
}) => (
  <h2
    className={cn(
      'm-0 text-pretty font-medium [text-box-trim:trim-both]',
      isSmall ? 'text-base lg:text-sm' : 'text-base',
      className
    )}
  >
    {children}
  </h2>
);
